import { Injectable, isDevMode } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import * as Mock from 'mockjs';
import { MockData } from '../../../mock/index';
import { log } from '@root/util/logger';
import { delay } from 'rxjs';

// import { environment } from "environments/environment";

@Injectable()
export class MockInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!isDevMode()) {
      return next.handle(req);
    }

    const url = req.url;
    // const method = req.method;
    const mockData = this.findMockData(url);
    if (mockData) {
      log(` 😈 Mock [${url}]`, Mock.mock(mockData));
      /** delay模拟异步 */
      return of(new HttpResponse({ body: Mock.mock(mockData) })).pipe(delay(3000));
    }

    return next.handle(req);
  }

  findMockData(url) {
    for (let key in MockData) {
      if (this.isMockUrl(key, url)) {
        return MockData[key];
      }
    }

    return null;
  }

  /** 暂时不区分method */
  isMockUrl(str, url) {
    if (str.startsWith('@ignore')) {
      return false;
    }

    if (str.indexOf(url) !== -1) {
      return true;
    }

    return false;
  }
}
